import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

// Singleton Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

export interface ProductMedia {
  url: string;
  type: string;
}

export interface ProductCategory {
  id: number;
  name: string;
  sort_order: number;
}

export interface Product {
  id: number;
  name: string;
  category_id: number | null;
  status: string;
  description: string | null;
  pricing_mode: number;
  currency: string;
  price: number | null;
  stock: number | null;
  discount_enabled: boolean;
  discount_price: number | null;
  media: ProductMedia[];
  created_at: string;
  updated_at: string;
  product_categories?: ProductCategory | null;
}

export function getPrimaryImage(product: Pick<Product, "media">): string {
  if (Array.isArray(product.media) && product.media.length > 0 && product.media[0]?.url) {
    return product.media[0].url;
  }
  return "https://readdy.ai/api/search-image?query=Handcrafted%20wooden%20children%20toy%20displayed%20on%20soft%20cream%20pastel%20background%20with%20dried%20flowers%2C%20editorial%20product%20photography%2C%20warm%20natural%20lighting%2C%20minimalist%20composition&width=600&height=800&seq=toy-placeholder-01&orientation=portrait";
}

export function getEffectivePrice(product: Pick<Product, "price" | "discount_enabled" | "discount_price">): number {
  if (product.discount_enabled && product.discount_price != null) {
    return Number(product.discount_price);
  }
  return Number(product.price ?? 0);
}

export function formatPrice(amount: number, currency = "EUR"): string {
  const symbol = currency === "EUR" ? "€" : currency === "USD" ? "$" : `${currency} `;
  return `${symbol}${amount.toFixed(2)}`;
}